module.exports = __webpack_public_path__ + "static/product-swirl-383fbf29dfe779e3ecd97b00c5f96b5b.png";